// HOOKS
import { createContext, useEffect } from "react";
import useGetManyCustomers from "../../hooks/customers/useGetMany.customer";
import useUpdateCustomer from "../../hooks/customers/useUpdate.customer";

export const CustomersContext = createContext({
  customers: [],
  setCustomers: () => {},
  getCustomers: () => {},
  updateCustomer: () => {},
  metaData: {},
  setMetaData: () => {},
  customerInput: {},
  setCustomerInput: () => {},
  query: {},
  setQuery: () => {},
  handleLimitChange: () => {},
  handlePageChange: () => {},
  handleSearch: () => {},
  handleSort: () => {},
  loading: false,
  error: null,
});

export const CustomersProvider = ({ children }) => {
  const { updateCustomer } = useUpdateCustomer();
  const {
    customers,
    setCustomers,
    getCustomers,
    metaData,
    setMetaData,
    customerInput,
    setCustomerInput,
    setQuery,
    query,
    handleLimitChange,
    handlePageChange,
    handleSearch,
    handleSort,
    loading: isLoading,
    error,
  } = useGetManyCustomers();

  const handleChange = async (customer) => {
    try {
      const res = await updateCustomer(customer);
      
      // If response contains error, throw it
      if (!res || res.error) {
        throw new Error(res?.error || "Failed to update customer");
      }

      // Update state with new customer data
      setCustomers((prevCustomers) =>
        prevCustomers.map((c) =>
          c._id === customer._id ? { ...c, ...customer } : c
        )
      );

      console.log("Customer updated successfully:", res);
    } catch (error) {
      console.error("Error in handleChange:", error);
    }
  };

  return (
    <CustomersContext.Provider
      value={{
        customers,
        setCustomers,
        getCustomers,
        updateCustomer,
        metaData,
        setMetaData,
        customerInput,
        setCustomerInput,
        setQuery,
        query,
        handleChange, // Ensure handleChange is available in context
        handleLimitChange,
        handlePageChange,
        handleSearch,
        handleSort,
        loading: isLoading,
        error,
      }}
    >
      {children}
    </CustomersContext.Provider>
  );
};
